import { useState } from 'react';
import { motion } from 'framer-motion';
import { subscribeNewsletter } from '../../lib/api';

export function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    try {
      const result = await subscribeNewsletter(email);
      setStatus('success');
      setMessage(result.message);
      setEmail('');
    } catch (err) {
      setStatus('error');
      setMessage(err instanceof Error ? err.message : 'Something went wrong');
    }
  };

  return (
    <section className="py-20 sm:py-28 bg-bg">
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="font-serif text-3xl font-bold text-text mb-4">
            One calm decision at a time
          </h2>
          <p className="text-text-light mb-8">
            Occasional notes on money: plainly explained, judgment-free. No hype, no hustle, no spam.
          </p>

          {status === 'success' ? (
            <div className="bg-sage/10 text-sage-dark px-6 py-4 rounded-lg font-medium">
              {message}
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
              <label htmlFor="newsletter-email" className="sr-only">Email address</label>
              <input
                id="newsletter-email"
                type="email"
                required
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 px-4 py-3 rounded-lg border border-sage/30 bg-white text-text placeholder:text-text-light/50 focus:outline-none focus:ring-2 focus:ring-sage/50 transition"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="px-6 py-3 rounded-lg bg-sage text-white font-semibold hover:bg-sage-dark disabled:opacity-60 transition-colors whitespace-nowrap"
              >
                {status === 'loading' ? 'Subscribing...' : 'Subscribe'}
              </button>
            </form>
          )}
          {status === 'error' && (
            <p className="mt-3 text-sm text-red-600">{message}</p>
          )}
        </motion.div>
      </div>
    </section>
  );
}
